import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "43",
  viewBox: "0 0 51.498 51.498"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Group 4218" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8010",
    d: "M17 8v10.893h12.449v-3.112h-9.337V8z",
    transform: "translate(6.549 1.416)",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8011",
    d: "M19.118 24.559a8.559 8.559 0 1 0-8.559 8.559 8.418 8.418 0 0 0 4.746-1.447l6.116 6.116 2.365-2.365-6.116-6.116a8.418 8.418 0 0 0 1.448-4.747zm-8.559 5.447a5.446 5.446 0 1 1 3.851-1.6 5.446 5.446 0 0 1-3.851 1.6z",
    transform: "translate(-2 6.063)",
    style: {"fill":"#fff"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8012",
    d: "M25.118 2A17.118 17.118 0 0 0 8 19.118a10.02 10.02 0 0 0 .078 1.556 11.661 11.661 0 0 1 3.237.7 14.006 14.006 0 1 1 13.8 11.749 13.833 13.833 0 0 1-6.225-1.556v.716a11.978 11.978 0 0 1-.3 2.6A17.118 17.118 0 1 0 25.118 2z",
    transform: "translate(1.614 -2)",
    style: {"fill":"#fff"}
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };